import React from 'react'
import './allActivities.css'
import profile from '../../assets/profile.png'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { handleClearNotifications } from '../../state/userSlice'


const AllActivities = () => {
    const {user, notifications} = useSelector((state)=>state.user)
    const dispatch = useDispatch()

    const handleClearAll = () => {
        dispatch(handleClearNotifications())
    }

    return (
        <section className="activities">
            {/* HEADING */}
            <div className="heading">
                <div className="heading__box">
                    <div className="heading-item">
                        <h3 className="heading-title">Activities| </h3>
                        <i class='bx bx-home heading__title-icon'></i>
                        <Link
                        to="/" className="heading-text">
                            Home <i class='bx bx-chevron-right heading-icon'></i>
                        </Link>
                        <span className="heading-text">
                        Activities <i class='bx bx-chevron-right heading-icon'></i>
                        </span>
                    </div>
                    <p className="heading-text">
                        All Activities
                    </p>
                </div>
                <button 
                onClick={handleClearAll}
                className="heading__box-btn button">
                    Clear all
                </button>
            </div>

            {/* ACTIVITIES CONTAINER */}
            <div className="activities__container">
                {
                    notifications?.map((item, i)=>(
                        item?.user !== user?._id &&
                        <div 
                        className="notification__items" key={i}>
                            <div className="notication__data">
                                <img src={profile} className="notification__img"/>
                                <div>
                                    <p className="notification__text">
                                        <b>{item?.userName ? item?.userName : ''}</b> {' '}
                                        {item?.like 
                                        ? (item?.postOwnerId === user?._id ? 'Like your post' 
                                        : item?.postOwnerId === item?.user ? 'Like his post' 
                                        : `Like ${item?.postOwnerName} post`)
                                        : item?.comment 
                                        ? (item?.postOwnerId === user?._id ? 'Comment on your post' 
                                        : item?.postOwnerId === item?.user ? 'Comment on his/her post'
                                        : `Comment on ${item?.postOwnerName} post`)
                                        : item?.message
                                    }
                                    </p>
                                    <span className="notification__date">
                                        {item?.date}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </section>
    )
}


export default AllActivities